import { DateTime } from 'luxon';

export default class Format {

    options = {
        locale: process.env.INTL_LOCALE || 'sv-SE',
        currency: process.env.CURRENCY || 'SEK'
    }

    constructor(style, decimals) {
        this.formatter = new Intl.NumberFormat(this.options.locale, { 
            style: style, 
            currency: this.options.currency, 
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals
        });
    }

    static currency(value, decimals = 0) {
        return (new this('currency', decimals)).formatter.format(value);
    }

    static number(value, decimals = 0) {
        return (new this('decimal', decimals)).formatter.format(value);
    }

    static percentage(value, decimals = 2) {
        return `${(new this('decimal', decimals)).formatter.format(value)} %`;
    }

    static excerpt(string, length = 100) {
        return string.substr(0, 100) + '...';
    }

    static date(dateIso, luxonFormatKey = 'DATE_SHORT') {
        const dt = DateTime.fromISO(dateIso);
        return dt.toLocaleString(DateTime[luxonFormatKey]);
    }
}